import { AlgoliaProductHit } from "../components/types/HitProps";

export function GetProductGtm(
  hit: AlgoliaProductHit,
  actualPrice: number,
  discount: number
) {
  return {
    id: hit.objectID,
    algoliaId: hit.objectID,
    name: hit.name,
    brand: hit.brand,
    category: "",
    variant: hit.variants?.[0]?.size || "",
    price: actualPrice,
    productDiscount: discount,
  };
}
